import { useCallback, useState } from "react";
import { mensagemAmigavel } from "./erros.ts";

export interface TrocarSenhaForm {
  senhaAtual: string;
  setSenhaAtual: (v: string) => void;
  nova: string;
  setNova: (v: string) => void;
  confirma: string;
  setConfirma: (v: string) => void;
  erro: string | null;
  sucesso: boolean;
  enviando: boolean;
  submeter: () => Promise<void>;
}

/**
 * Lógica do formulário "trocar minha senha", compartilhada entre mobile e
 * desktop. Valida no cliente com mensagens amigáveis antes de chamar a API e
 * traduz os erros do servidor (ex.: senha atual incorreta).
 */
export function useTrocarSenha(
  trocar: (senhaAtual: string, novaSenha: string) => Promise<void>,
): TrocarSenhaForm {
  const [senhaAtual, setSenhaAtual] = useState("");
  const [nova, setNova] = useState("");
  const [confirma, setConfirma] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [sucesso, setSucesso] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const submeter = useCallback(async () => {
    setErro(null);
    setSucesso(false);
    if (!senhaAtual) {
      setErro("Digite sua senha atual.");
      return;
    }
    if (nova.length < 8) {
      setErro("A nova senha precisa ter ao menos 8 caracteres.");
      return;
    }
    if (nova !== confirma) {
      setErro("A confirmação não confere com a nova senha.");
      return;
    }
    if (nova === senhaAtual) {
      setErro("A nova senha deve ser diferente da atual.");
      return;
    }
    setEnviando(true);
    try {
      await trocar(senhaAtual, nova);
      setSucesso(true);
      setSenhaAtual("");
      setNova("");
      setConfirma("");
    } catch (e) {
      setErro(mensagemAmigavel(e));
    } finally {
      setEnviando(false);
    }
  }, [senhaAtual, nova, confirma, trocar]);

  return {
    senhaAtual,
    setSenhaAtual,
    nova,
    setNova,
    confirma,
    setConfirma,
    erro,
    sucesso,
    enviando,
    submeter,
  };
}
